/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
import type { ShopperProducts } from '@salesforce/storefront-next-runtime/scapi';
import { useConfig } from '@salesforce/storefront-next-runtime/config';
import B2bFooter from '@/components/footer/b2b-footer';
import CheckoutFooter from '@/components/footer/checkout-footer';
import MainFooter from '@/components/footer/main-footer';

interface FooterProps {
    categories?: Promise<ShopperProducts.schemas['Category']>;
    variant?: 'full' | 'checkout';
}

export default function Footer({ categories, variant = 'full' }: FooterProps): ReactElement {
    const config = useConfig();

    if (config.features.b2b.enabled && config.features.b2b.isSimpleFooter) {
        return <B2bFooter />;
    }

    return variant === 'checkout' ? <CheckoutFooter /> : <MainFooter categories={categories} />;
}
